import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/Footer";
import { SolutionIndustryCustomer } from "../../../blocks/solution-industry-customer";
import { SolutionIndustrySupport } from "../../../blocks/solution-industry-support";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { useTranslation } from "react-i18next";
import { SolutionIndustryBanner } from "../../../blocks/solution-industry-banner";
import { SolutionSceneSwitchScreen } from "../../../blocks/solution-scene-wechat";
import { SolutionSceneIntro } from "../../../blocks/solution-scene-intro";
import { SolutionSceneValue } from "../../../blocks/solution-scene-value";

export const WechatPage = () => {
  const { t } = useTranslation();
  const select_list = [
    {
      subLabel: t("solution.wechat.type.item1.title"),
      content: t("solution.wechat.type.item1.descript"),
      imgUrl: "//files.authing.co/authing-website/wechat-pc-scan-login-v2.png",
      docLink: "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-pc/",
    },
    {
      subLabel: t("solution.wechat.type.item2.title"),
      content: t("solution.wechat.type.item2.descript"),
      imgUrl:
        "//files.authing.co/authing-website/wechat-mini-login-scan-v3.png",
      docLink:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-qrcode/",
    },
    {
      subLabel: t("solution.wechat.type.item3.title"),
      content: t("solution.wechat.type.item3.descript"),
      imgUrl: "//files.authing.co/authing-website/wechat-mobile-login-v2.png",
      docLink:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-mobile.html",
    },
    {
      subLabel: t("solution.wechat.type.item4.title"),
      content: t("solution.wechat.type.item4.descript"),
      imgUrl:
        "//files.authing.co/authing-website/wechat-mobile-mini-program-login-v2.png",
      docLink:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-applaunch.html",
    },
    {
      subLabel: t("solution.wechat.type.item5.title"),
      content: t("solution.wechat.type.item5.descript"),
      imgUrl: "//files.authing.co/authing-website/wechat-web-authorize.png",
      docLink:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-webpage-authorization.html",
    },
    {
      subLabel: t("solution.wechat.type.item6.title"),
      content: t("solution.wechat.type.item6.descript"),
      imgUrl:
        "//files.authing.co/authing-website/wechat-mini-program-login-v3.png",
      docLink:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram.html",
    },
  ];
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  return (
    <div className="wechat-page">
      <Header mode="light" />
      <SolutionIndustryBanner
        title={t("solution.wechat.banner.title")}
        subtitle={t("solution.wechat.banner.subtitle")}
        imgUrl="//files.authing.co/authing-website/solution-banner-wechat-v2.png"
      />
      {/* <SolutionIndustryCustomer /> */}
      <SolutionSceneIntro scene={t("solution.wechat.intro")} />
      <SolutionSceneValue value={t("solution.wechat.value")} />
      <SolutionSceneSwitchScreen featureList={select_list} hasDoc />
      <SolutionIndustrySupport
        supportTitle={t("solution.scene.title-support")}
        noLastBlock
      />
      <CommonPageLink pagesLink={pagesLink} />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
